import { createTheme } from "@mui/material/styles";

// Shared primary palette: every MUI theme starts here, including nested
// providers. Semantic error/warning/success and disabled colors stay intact.
export const RIGHTWORK_PRIMARY = Object.freeze({
  main: "#6d28d9", light: "#ede9fe", dark: "#5b21b6", contrastText: "#ffffff",
});

export function createRightworkTheme(options = {}) {
  return createTheme({
    ...options,
    palette: { ...options.palette, primary: { ...RIGHTWORK_PRIMARY } },
  });
}

const rightworkTheme = createRightworkTheme();
export default rightworkTheme;
